import Router from 'vue-router'
import PortalHomePage from "@/pages/PortalHomePage";
import Unauthorized from "@/pages/Unauthorized";
import VueRouter from "vue-router";
import Vue from 'vue';
import Announcements from "@/pages/Announcements";
import Help from "@/pages/PortalHelp";
import Login from "@/pages/Login"
import Property from "@/pages/PropertyInfo";
import UnitDetails from "@/pages/UnitDetails";
import ChangeUnitDetails from "@/pages/ChangeUnitDetails";
import ChangeUnitSecret from "@/pages/ChangeUnitSecret";
import DeviceDetails from "@/pages/DeviceDetails";
import LoggedOut from "@/pages/LoggedOut";
import ChangePortalAccessToken from "@/pages/ChangePortalAccessToken";
import ChangeUnitPhoneDetails from "@/pages/ChangeUnitPhoneDetails";
import store from "@/store/store";
import ChangeIdentityDetails from '@/pages/ChangeIdentityDetails.vue';
import ChangeDeviceDetails from '@/pages/ChangeDeviceDetails.vue';
Vue.use(VueRouter)

const ifIsTenantSetSecret = async (to, from, next) => {
    //Block the user from going to the page directly if not permitted.
  console.log("store for getIsTenantSetSecret is: " + store.getters.getIsTenantSetSecret)
  if(store.getters.getIsTenantSetSecret) {
      next()
      return
    }
  return next({name: 'PortalHomePage'});
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/portal/',
      alias: '/portal',
      name: 'PortalHomePage',
      component: PortalHomePage,
    },
    {
      path: '/portal/property',
      name: 'Property',
      component: Property
    },
    {
      path: '/portal/contact',
      name: 'Unit',
      component: UnitDetails
    },
    {
      path: '/portal/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/portal/changeUnitDetails',
      name: 'ChangeUnitDetails',
      component: ChangeUnitDetails,
      props:true
    },
    {
      path: '/portal/changeIdentityDetails',
      name: 'ChangeIdentityDetails',
      component: ChangeIdentityDetails,
      props:true
    },
    {
      path: '/portal/changeUnitSecret',
      name: 'ChangeUnitSecret',
      component: ChangeUnitSecret,
      props:true,
      beforeEnter: ifIsTenantSetSecret
    },
    {
      path: '/portal/changePhoneNumberDetails',
      name: 'ChangeUnitPhoneDetails',
      component: ChangeUnitPhoneDetails,
      props:true
    },
    {
      path: '/portal/changeDeviceDetails',
      name: 'ChangeDeviceDetails',
      component: ChangeDeviceDetails,
      props:true
    },
    {
      path: '/portal/unauthorized',
      name: 'Unauthorized',
      component: Unauthorized,
      props:true
    },
    {
      path: '/portal/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/portal/announcements',
      name: 'Announcements',
      component: Announcements
    },
    {
      path: '/portal/device',
      name: 'Device',
      component: DeviceDetails,
      props:true
    },
    {
      path: '/portal/changeAccessToken',
      name: 'ChangeAccessToken',
      component: ChangePortalAccessToken,
      props:true
    },
    {
      path: '/portal/loggedOut',
      name: 'loggedOut',
      component: LoggedOut,
    },
    { 
      path: '/portal/*',
      redirect: { name: 'PortalHomePage' }
    }
  ]

})



